import React from "react";
import "./mobile-download.css";

const APK_URL = process.env.REACT_APP_MOBILE_APK_URL || "/downloads/fmsar-vhu-mobile.apk";
const API_URL = process.env.REACT_APP_API_URL || "https://jaeval.com/api";
const APK_FILENAME = "fmsar-vhu-mobile.apk";

function MobileDownloadPage() {
  return (
    <main className="mobile-download-page">
      <section className="mobile-download-hero">
        <div className="mobile-download-copy">
          <img src="/logo.jpeg" alt="Jaeval" className="mobile-download-logo" />
          <span className="mobile-download-kicker">Application mobile</span>
          <h1>Jaeval VHU</h1>
          <p>
            Acces mobile pour les ferrailleurs et acheteurs: consulter les lots
            VHU autorises, soumettre une offre globale en MAD et suivre les
            achats attribues.
          </p>

          <div className="mobile-download-actions">
            <a className="mobile-download-primary" href={APK_URL} download>
              <i className="ri-download-cloud-2-line" />
              Telecharger APK
            </a>
            <a className="mobile-download-secondary" href="/login">
              <i className="ri-dashboard-line" />
              Espace web
            </a>
          </div>

            <div className="mobile-download-meta">
              <span><i className="ri-shield-check-line" /> Connexion JWT securisee</span>
              <span><i className="ri-android-line" /> APK: <a href={APK_URL} download>{APK_FILENAME}</a></span>
              <span><i className="ri-server-line" /> API: {API_URL}</span>
            </div>
        </div>

        <div className="mobile-download-preview" aria-label="Apercu application mobile">
          <div className="mobile-phone">
            <div className="mobile-phone-top" />
            <div className="mobile-phone-screen">
              <div className="mobile-app-bar">
                <span>Lots VHU</span>
                <i className="ri-refresh-line" />
              </div>
              <div className="mobile-lot-card">
                <span>VHU-2026-001</span>
                <strong>Lot utilitaires sinistres</strong>
                <small>5 vehicules - Fin: 14/06/2026</small>
                <b>86 000 MAD</b>
              </div>
              <div className="mobile-lot-card compact">
                <span>OFFRE D'ACHAT</span>
                <strong>Montant global en MAD</strong>
                <small>Paiement 24h - Enlevement 48h</small>
              </div>
              <div className="mobile-lot-card compact">
                <span>VHU-2026-002</span>
                <strong>Lot citadines reformees</strong>
                <small>8 vehicules</small>
              </div>
              <div className="mobile-nav">
                <i className="ri-car-line active" />
                <i className="ri-calculator-line" />
                <i className="ri-file-list-3-line" />
                <i className="ri-user-line" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mobile-download-steps">
        <article>
          <i className="ri-android-line" />
          <h2>Installation Android</h2>
          <p>Telechargez l'APK, ouvrez le fichier sur le telephone, puis autorisez l'installation si Android le demande.</p>
        </article>
        <article>
          <i className="ri-lock-password-line" />
          <h2>Connexion</h2>
          <p>Utilisez votre identifiant ferrailleur et votre mot de passe. Le token est conserve localement pour les prochains acces.</p>
        </article>
        <article>
          <i className="ri-auction-line" />
          <h2>Offres VHU</h2>
          <p>Chaque offre est un montant global en MAD avec delais de paiement, delai d'enlevement, moyen de paiement et acceptation des conditions.</p>
        </article>
      </section>
    </main>
  );
}

export default MobileDownloadPage;
